export function scrollXComponente(className: string) {
  const scrollContainer = document.querySelector(className) as HTMLElement;

  scrollContainer.addEventListener('wheel', (evt: WheelEvent) => {
    evt.preventDefault();
    scrollContainer.scrollLeft += evt.deltaY;
  });

  let isDown = false;
  let startX;
  let scrollLeft;

  scrollContainer.addEventListener('mousedown', (e: MouseEvent) => {
    isDown = true;
    scrollContainer.classList.add('scrolling');
    startX = e.pageX - scrollContainer.offsetLeft;
    scrollLeft = scrollContainer.scrollLeft;
  });

  scrollContainer.addEventListener('mouseleave', () => {
    isDown = false;
    scrollContainer.classList.remove('scrolling');
  });

  scrollContainer.addEventListener('mouseup', () => {
    isDown = false;
    scrollContainer.classList.remove('scrolling');
  });

  scrollContainer.addEventListener('mousemove', e => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - scrollContainer.offsetLeft;
    const walk = (x - startX) * 2; // Multiplica a velocidade
    scrollContainer.scrollLeft = scrollLeft - walk;
  });
}
